export class FeatureFlags {
  public static get EnableMiniProfiler(): boolean {
    // return process.env.NODE_ENV === 'development';
    return false;
  }

  public static get MatomoUrl(): string {
    return import.meta.env?.REACT_APP_MatomoUrl ?? '';
  }
  public static get MatomoSiteId(): number {
    return parseInt(import.meta.env?.REACT_APP_MatomoSiteId);
  }

  public static get VoiceRecognitionEnabled(): boolean {
    return toBoolean(import.meta.env.REACT_APP_VoiceRecognitionEnabled);
  }

  public static get EnablePrivilegedModeOnWeb(): boolean {
    return toBoolean(import.meta.env.REACT_APP_PrivilegedModeEnabledOnWeb);
  }

  public static get TotpSecretForTests(): string {
    return import.meta.env?.REACT_APP_TOTP_SECRET_TESTS ?? '';
  }

  public static get EnableSignalViewer(): boolean {
    return toBoolean(import.meta.env.REACT_APP_IsSignalViewerEnabled);
  }
}

/*
 * This function converts 'false', '0', null, undefined to boolean `false`
 * Everything else is converted to boolean `true`.
 * (all default conversions like `!!value` or `Boolean(value)` do not convert 'false' to boolean false
 */
function toBoolean(value: string): boolean {
  if (!value) return false;

  const lowercaseValue = value.toLowerCase();
  return !(lowercaseValue === 'false' || lowercaseValue === '0');
}
